import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { CarrierAccountService } from 'app/services/carrier-account.service';
import { AuthWebService } from 'app/services/authweb.service';
import { PopupService } from 'app/services/shared/popup.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

export interface YesNoModel {
  title: string;
  message: string;
  comment: string;
  confirmButtonText: string;
  cancelButtonText: string;
  person: any;
  carrierID: number;
  carrierData: any;
  edit: boolean;
}

@Component({
  selector: 'yesno',
  template: `<div #thisModal class="modal-dialog" style="none!important;width:380px!important;top:50px!important;">
                <div class="modal-content bgd-c" style="border:none!important;">                   
                   <div class="modal-body" style="border:none!important;">
                     <p class="h6" style="color:white!important;">{{title || 'Confirmation'}}</p>
                     <small class="extra-clr ft-c">{{message}}</small><br/>
                     <small class="text-small" style="color:white!important;font-size:10px!important">{{comment}}</small>          
                      <select #roleServed (change)="roleChange(roleServed)" class="form-control form-control-sm" name="role" style="margin-top: 10px; margin-bottom: 5px;">
                        <option value="" disabled selected>Select Role</option>
                        <option *ngFor="let role of roles" [value]="role.role" >{{role.desc}}</option>
                      </select>   
                   <div style="border:none!important;height:20px!important;margin-top:10px!important;">                     
                     <button type="button" class="btn btn-danger btn-sm pull-right" style="margin-right:4px!important;" (click)="cancel()">{{cancelButtonText || 'No'}}</button>
                     <button [disabled]="proceedDisabled" type="button" class="btn btn-primary btn-sm pull-right" style="margin-right:4px!important;padding-right:4px!important;" (click)="confirm(thisModal)">{{confirmButtonText || 'Yes'}}</button>
                   </div>
                  </div>
                 </div>
                </div>`,
  styles: [`
   .bgd-c{background:rgb(57, 50,118 )!important;}
   .ft-c{color: rgb(253, 207,76 )!important;}   
 `]
})
export class AssignRolePopupComponent extends DialogComponent<YesNoModel, boolean> implements YesNoModel {
  title: string;
  message: string;
  comment: string;
  confirmButtonText: string;
  cancelButtonText: string;
  person: any;
  carrierID: number;
  roleServedInd: number;
  carrierData: any;
  edit: boolean;
  roles: any = [
    { role: 1, desc: "Lead User" },
    { role: 2, desc: "Editor User" },
    { role: 6, desc: "Read User" },
    { role: 11, desc: "Owner" },
    { role: 12, desc: "Consultant" },
    { role: 21, desc: "Main Contact" }
  ];
  proceedDisabled = true;
  constructor(dialogService: DialogService, private toastService:ToastNotificationService,
    private carrierAccountService: CarrierAccountService, private authWebService: AuthWebService, private showModal: PopupService, private toaster: ToastrService,private confirmDialogService: ConfirmDialogService) {
    super(dialogService);
  }

  confirm(thisModal) {
    thisModal.style.display = "none";
    // this.showModal.showYesNo(this.edit ? 'Change User Role' : 'Link user', "You have selected '" + this.roles.find(r => r.role == this.roleServedInd).desc + " Role' for user " + this.person.first_name + " " + this.person.last_name,
    //   "Do you want to send user a One time Password to link them to " + this.carrierData.name + " account?", 'Yes', 'No').subscribe((isConfirmed) => {
    //     if (isConfirmed) {
    //       if (this.edit) {
    //         this.carrierAccountService.changeRoleForCarrierPerson(this.carrierID, this.person.person_id, this.roleServedInd, this.authWebService.userData.User.UserName).subscribe(result => {
    //           this.toaster.success('The role for ' + this.person.first_name + " " + this.person.last_name + ' has been changed succesfully.');
    //           this.result = true;
    //           this.close();
    //         });
    //       }
    //       else {
    //         this.carrierAccountService.linkCarrrierPerson(this.carrierID, this.person.person_id, this.roleServedInd, this.authWebService.userData.User.UserName).subscribe(result => {
    //           if (result == "Person already linked.") {
    //             this.toaster.warning(this.person.first_name + " " + this.person.last_name + ' is already linked to ' + this.carrierData.name + ' account and cannot be linked again.');
    //             this.result = false;
    //             this.close();
    //           }
    //           else if (result == "success") {
    //             this.toaster.success(this.person.first_name + " " + this.person.last_name + ' has been sent an OTP to link your Account: ' + this.carrierData.name +' . Please check your email.');
    //             this.result = true;
    //             this.close();
    //           } else {
    //             this.result = false;
    //             this.close();
    //           }

    //         });
    //       }
    //     } else {
    //       this.result = false;
    //       this.close();
    //     }

    //   });
      this.confirmDialogService.confirmThis("You have selected '" + this.roles.find(r => r.role == this.roleServedInd).desc + " Role' for user " + this.person.first_name + " " + this.person.last_name +". Do you want to send user a One time Password to link them to " + this.carrierData.name + " account?", () => {  
        if (this.edit) {
          this.carrierAccountService.changeRoleForCarrierPerson(this.carrierID, this.person.person_id, this.roleServedInd, this.authWebService.userData.User.UserName).subscribe(result => {
            this.toastService.success('The role for ' + this.person.first_name + " " + this.person.last_name + ' has been changed succesfully.','success');
            this.result = true;
            this.close();
          });
        }
        else {
          this.carrierAccountService.linkCarrrierPerson(this.carrierID, this.person.person_id, this.roleServedInd, this.authWebService.userData.User.UserName).subscribe(result => {
            if (result == "Person already linked.") {
              this.toastService.error(this.person.first_name + " " + this.person.last_name + ' is already linked to ' + this.carrierData.name + ' account and cannot be linked again.','Error');
              this.result = false;
            }
            else if (result == "success") {
              this.toastService.success(this.person.first_name + " " + this.person.last_name + ' has been sent an OTP to link your Account: ' + this.carrierData.name +' . Please check your email.','success');
              this.result = true;
            } else {
              this.result = false;
            }

          });
        }

      
      }, () =>  {  
        this.result = false;
      }) 
  }
  cancel() {
    this.result = false;
    this.close();
  }
  roleChange(roleServed) {
    this.proceedDisabled = false;
    this.roleServedInd = roleServed.value;
  }
}
